import React, { useEffect } from "react";
import "./Resources.css";
import Background from "../../hero-pattern.svg";
import { AspectRatio, Stack, Typography } from "@mui/joy";
import LearnTheProcess from "./LearnTheProcess";
import FrequentlyAskedQuestions from "./TakeActions";
import TypesOfLegislation from "./TypesOfLegislation";

function Resources() {
  useEffect(() => {
    document.title = "Resources | Civic Engage";
  }, []);

  return (
    <Stack
      className="hero-image"
      direction={"column"}
      sx={{
        alignItems: "center",
        backgroundImage: "url(" + Background + ")",
      }}
    >
      <Stack
        direction={{ xs: "column", md: "row" }}
        spacing={6}
        padding={8}
        sx={{
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          maxWidth: "1280px",
        }}
      >
        <Stack direction="column" spacing={1} sx={{ width: "75%" }}>
          <Typography level="h1" style={{ textAlign: "left" }}>
            Welcome to the Resources Hub!
          </Typography>
          <Typography level="body-lg" style={{ textAlign: "left" }}>
            Whether you're looking to understand how laws are made, find ways to
            get involved, or explore trusted organizations fighting for change,
            this page has you covered. Start by watching Schoolhouse Rock: How a
            Bill Becomes a Law for a classic breakdown of the legislative
            process, then dive into links and tools to help you take action and
            stay informed.
          </Typography>
        </Stack>
        <AspectRatio
          ratio="560 / 315"
          objectFit="contain"
          flex={true}
          color="transparent"
          sx={{
            overflow: "auto",
            flexBasis: "auto",
            width: "80%",
          }}
        >
          <iframe
            src="https://www.youtube.com/embed/men-vp5jvzI?si=M1LsYPh7A05lnMsU"
            title="Schoolhouse Rock: How a Bill Becomes a Law"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </AspectRatio>
      </Stack>
      <Stack direction={"column"} sx={{ maxWidth: "1280px" }}>
        <LearnTheProcess />
        <TypesOfLegislation />
        <FrequentlyAskedQuestions />
      </Stack>
    </Stack>
  );
}

export default Resources;
